<template>
  <div class="">
    <div class="row justify-center gutter-md">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <project-businesskit-assignement
          class="project-assignment-row"
          @update="updateBusinesskits"
          :businesskits="businesskits"
          :assigned-businesskits="assigned_businesskits"
        />
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <project-user-assignement
          class="project-assignment-row"
          @update="updateUsers"
          :users="users"
          :assigned-users="assigned_users"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ProjectApi from '@/api/Project.js'
import UserApi from '@/api/User.js'
import BusinessKitApi from '@/api/BusinessKit.js'
import Ui from '@/classes/Ui'
import ProjectUserAssignement from './ProjectUserAssignement'
import ProjectBusinesskitAssignement from './ProjectBusinesskitAssignement'

export default {
  components: {
    ProjectUserAssignement,
    ProjectBusinesskitAssignement,
  },
  data() {
    return {
      users: [],
      assigned_users: [],
      user_to_assign: 0,
      businesskits: [],
      assigned_businesskits: [],
      businesskit_to_assign: 0,
      projectNavigation: [
        { name: "project_leads", action: "project_leads.list", redential: "project_leads.list"},
        { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" },
        { name: "project_edit", action: "project.edit", credential: "projects.update" },
        { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }
      ],
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.getCurrentProject
    }
  },
  async mounted() {
    Ui.startLoading()
    if (!this.currentProject) {
      await this.retrieveProject()
    }
    this.setupSecondaryHeader()
    this.retrieveUsers()
    this.retrieveBusinesskits()
  },
  methods: {
    setupSecondaryHeader() {
      Ui.setSecondaryHeaderTabs(this.projectNavigation)
      Ui.clearHeaderButtons()
      Ui.setPageLevel("3")
      Ui.setSubtitle({link: {name: "projects"}})
      Ui.setTitle({ label: "ui.pages.project-edit", params: { name: this.currentProject.name } })
      Ui.setPageType('project')
    },
    async retrieveProject() {
      let api     = new ProjectApi
      let id      = this.$route.params.id
      let project = await api['show'](id)
      this.$store.commit('SET_CURRENT_PROJECT', project)
    },
    async retrieveUsers() {
      // Fetch all users in organizations
      let api      = new UserApi()
      let response = await api.all({organization_id: this.currentProject.organization_id, per_page: 1000})
      this.users   = response.resources

      // Fetch which users are already assigned
      response = await api.all({project_id: this.currentProject.id, per_page: 1000})
      response.resources.forEach(user=>{
        this.assigned_users.push(user.id)
      })
    },
    async retrieveBusinesskits() {
      // Retrieve all businesskits
      let api           = new BusinessKitApi()
      let response      = await api.all({organization_id: this.currentProject.organization, per_page: 1000})
      this.businesskits = response.resources

      // Retrieve assigned businesskits
      response = await api.all({project_id: this.currentProject.id, per_page: 1000})
      response.resources.forEach(bk=>{
        this.assigned_businesskits.push(bk.id)
      })
      Ui.finishLoading()
    },
    async updateUsers(users) {
      try {
        let api             = new ProjectApi()
        let response        = await api.assign_users(users, this.currentProject.id)
        this.assigned_users = users
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.project.message.update',
          'type': 'success'
        })
      } catch(err) {
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + err.response.data.errors[0].code,
          'type': 'error'
        })
      }
    },
    async updateBusinesskits(bks) {
      try {
        let api                    = new ProjectApi()
        let response               = await api.assign_businesskits(bks, this.currentProject.id)
        this.assigned_businesskits = bks
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.project.message.update',
          'type': 'success'
        })
      } catch(err) {
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + err.response.data.errors[0].code,
          'type': 'error'
        })
      }
    },
  },
  watch: {
    currentProject() {
      this.item = this.currentProject
    }
  }
}
</script>
<style lang="sass" scoped>
  .justify-center
    justify-content: center

</style>



// WEBPACK FOOTER //
// ProjectAssignments.vue?33013945